/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import ClientsService from '../../services/ClientsService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_CLIENTS = 'SET_CLIENTS';
const CLEAR_CLIENTS = 'CLEAR_CLIENTS';

const state = {
  clients: null,
};

const getters = {
  getClientById: (state) => (id) => state.clients.find((x) => x.id === id),
};

const mutations = {
  [SET_CLIENTS](state, clients) {
    state.clients = clients;
  },
  [CLEAR_CLIENTS](state) {
    state.clients = null;
  },
};

const actions = ({
  loadClients({ commit }, activeSiteId) {
    ClientsService.getClients(activeSiteId)
      .then((x) => x.data)
      .then((clientsResult) => {
        commit(SET_CLIENTS, clientsResult.clients);
      }).catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  createClient({ dispatch }, client) {
    return ClientsService.createClient(client)
      .then((x) => x.data)
      .then((clientData) => {
        dispatch('loadClients', clientData.client.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  updateClient({ dispatch }, clientUpdate) {
    return ClientsService.updateClient(clientUpdate)
      .then((x) => x.data)
      .then((clientData) => {
        dispatch('loadClients', clientData.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  deleteClient({ dispatch, rootState }, id) {
    const activeSiteId = rootState.userStore.activeSite
      ? rootState.userStore.activeSite.id
      : rootState.userStore.user.activeSite.id;

    return ClientsService.deleteClient(id)
      .then((x) => dispatch('loadClients', activeSiteId))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
